module.exports = __webpack_public_path__ + "img/white-logo.814a9d7.png";